module.exports = "/images/city.svg";